import React from 'react';
import SvgIcon from './SvgIcon';

const Menu = props => (
    <SvgIcon viewBox="0 0 26 24" {...props}>
        <path
            d="M1.75 12h13.5M1.75 5.25h22.5-22.5zM1.75 18.75h22.5"
            stroke="currentColor"
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Menu.displayName = 'MenuIcon';

export default Menu;
